var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var AsyncIterator = require('asynciterator');

var MultiTransformIterator = AsyncIterator.MultiTransformIterator;
var SimpleTransformIterator = AsyncIterator.SimpleTransformIterator; // https://en.wikipedia.org/wiki/Nested_loop_join

var NestedLoopJoin =
/*#__PURE__*/
function (_MultiTransformIterat) {
  "use strict";

  _inherits(NestedLoopJoin, _MultiTransformIterat);

  function NestedLoopJoin(left, right, funJoin) {
    var _this;

    _classCallCheck(this, NestedLoopJoin);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NestedLoopJoin).call(this, left));
    _this.right = right;
    _this.funJoin = funJoin; // function that joins 2 elements or returns null if join is not possible

    _this.on('end', function () {
      return _this.right.close();
    });

    return _this;
  }

  _createClass(NestedLoopJoin, [{
    key: "close",
    value: function close() {
      _get(_getPrototypeOf(NestedLoopJoin.prototype), "close", this).call(this);

      this.right.close();
    }
  }, {
    key: "_createTransformer",
    value: function _createTransformer(leftItem) {
      var _this2 = this;

      return new SimpleTransformIterator(this.right.clone(), {
        transform: function transform(rightItem, done) {
          var result = _this2.funJoin(leftItem, rightItem);

          if (result !== null) _this2._push(result);
          done();
        }
      });
    }
  }]);

  return NestedLoopJoin;
}(MultiTransformIterator);

module.exports = NestedLoopJoin;